export default __webpack_public_path__ + "static/media/eiffel.efe34614.svg";